import { ArrowUpRight } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { useI18n } from "@/lib/i18n";
import { SECTIONS } from "@/constants/testIds";

export default function Spotlight() {
  const { t } = useI18n();
  return (
    <section
      id="spotlight"
      data-testid={SECTIONS.spotlight}
      className="relative py-28 lg:py-40 overflow-hidden"
      style={{
        background:
          "radial-gradient(ellipse at 30% 20%, #1a1538 0%, #0a0816 40%, #050308 100%)",
      }}
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.08] pointer-events-none mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-16 items-center">
        <div className="lg:col-span-6">
          <div className="relative w-full max-w-md mx-auto aspect-[4/5]">
            <div className="absolute inset-0 bg-[#3a2a6a]/40 blur-3xl rounded-full" />
            <img
              src={ASSETS.heroBottle}
              alt="Noćna Tajna"
              className="relative w-full h-full object-cover shadow-[0_40px_100px_-20px_rgba(80,40,180,0.4)]"
            />
          </div>
        </div>
        <div className="lg:col-span-6 text-white">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#c5a572]" />
            <span className="text-[11px] tracking-[0.42em] text-[#c5a572] uppercase">
              {t.spotlight.eyebrow}
            </span>
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-[80px] leading-[0.95] tracking-tight">
            {t.spotlight.title}
          </h2>
          <p className="mt-4 font-serif italic text-[#c5a572] text-xl lg:text-2xl">
            {t.spotlight.tagline}
          </p>
          <p className="mt-8 text-white/70 leading-relaxed max-w-xl font-light">
            {t.spotlight.body}
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            {t.spotlight.attrs.map((a) => (
              <span
                key={a}
                className="text-[11px] tracking-[0.28em] uppercase border border-white/15 px-4 py-2 text-white/80"
              >
                {a}
              </span>
            ))}
          </div>

          <a
            href="#contact"
            className="group mt-12 inline-flex items-center gap-3 bg-[#c5a572] hover:bg-[#d4b685] text-[#0a0a0a] px-7 py-4 rounded-full text-[12px] tracking-[0.28em] uppercase font-medium transition-all duration-300"
          >
            {t.spotlight.cta}
            <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
}
